import { dayjsUtc } from 'lib/dayjs'

const END_TAX_MONTH_AND_DAY = '-04-05'
const START_TAX_MONTH_AND_DAY = '-04-06'
const TAX_YEAR_FORMAT = 'D MMMM YYYY'

export const getGiftTaxYears = (dateOfDeath) => {
  const yearOfDeath = dayjsUtc(dateOfDeath).year()
  let startTaxYear = dayjsUtc(`${yearOfDeath - 1}${START_TAX_MONTH_AND_DAY}`)
  let endTaxYear = dayjsUtc(`${yearOfDeath}${END_TAX_MONTH_AND_DAY}`)

  if (dayjsUtc(dateOfDeath).isAfter(endTaxYear)) {
    startTaxYear = dayjsUtc(`${yearOfDeath}${START_TAX_MONTH_AND_DAY}`)
    endTaxYear = dayjsUtc(`${yearOfDeath + 1}${END_TAX_MONTH_AND_DAY}`)
  }

  const taxDates = []
  for (let i = 0; i < 8; i++) {
    const startDate = startTaxYear.format(TAX_YEAR_FORMAT)
    const endDate = endTaxYear.format(TAX_YEAR_FORMAT)
    taxDates.push(`${startDate} - ${endDate}`)

    startTaxYear = startTaxYear.subtract(1, 'year')
    endTaxYear = endTaxYear.subtract(1, 'year')
  }

  return taxDates
}
